import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import "./Footer.css";

const pdfUrl = "https://jynperez.com.ar/catalogo/jynperezcatalogo.pdf";

const Footer = () => {
  return (
    <footer className="footer">
      <Container className="container-m-tablet-phone">
        <Row className="m-4">
          <Col lg={5} md={6} xs={12} className="text-left">
            <a href="/" aria-label="Ir a la página principal">
              <img
                src="/logo-nav.png"
                alt="Logo de JyN Perez - Industria Metalúrgica"
                className="logo"
              />
            </a>
            <p className="footer-description">
              Somos una fábrica que se dedica a la comercialización de artículos gastronómicos en alambre y tejido, que cuenta con muchos años de trayectoria en la industria.
            </p>
            <div className="footer-rights-container d-none d-md-block mt-3">
              <p className="footer-rights">J y N Perez | Industria Metalúrgica</p>
              <p>© {new Date().getFullYear()} Todos los derechos reservados.</p>
            </div>
          </Col>
          <Col lg={4} md={3} xs={12} className="text-left mt-md-4">
            <h5 className="footer-heading title-footer">Contacto</h5>
            <address>
              <p>
                Rivera Indarte 3548<br />
                C.P. C1437BGL - Capital Federal
              </p>
              <p className="mb-0">(011) 4918-6575 | 4919-4676</p>
              <p>WP | 11 5485 8252</p>
              <p>jynperez2020@gmail.com</p>
            </address>
          </Col>
          <Col lg={3} md={3} xs={12} className="text-left mt-md-4">
            <h5 className="footer-heading title-footer">Redes</h5>
            <p className="mb-0"><strong>¡Unite a nuestra comunidad!</strong></p>
            <nav aria-label="Redes sociales">
              <a
                href="https://www.instagram.com/metalurgicajynperez/"
                target="_blank"
                rel="noopener noreferrer"
                className="redes-style-footer"
              >
                @metalurgicajynperez
              </a>
            </nav>
            <div className="mt-3">
              <h6>Descargá nuestro catálogo:</h6>
              <QRCodeCanvas value={pdfUrl} size={100} />
              <p>
                <a href={pdfUrl} download className="link-qr">Hacé click aquí</a> para descargar
              </p>
            </div>
          </Col>
        </Row>
        <Row className="d-md-none mt-3 ms-3">
          <Col xs={10} className="text-left footer-rights-container">
            <p className="footer-rights">J y N Perez | Industria Metalúrgica</p>
            <p>© {new Date().getFullYear()} Todos los derechos reservados.</p>
          </Col>
        </Row>
        <Row>
          <Col xs={10} md={10} lg={12} className="m-hw">
            <p>Diseñado y Desarrollado por <a href="http://higherweb.com.ar" className="link-higherweb" target="blank">Higher Web</a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
